<div
  [class.idp-form-grouped--error]="errorState || error"
  [class.idp-input__add-margin]="addMargin"
  [ngClass]="{
    'idp-form-grouped': showFormGrouped,
    'idp-input-bottomMargin': bottomLabelText
  }"
>
  <div
    [class.idp-input__wrapper--error]="submitAttempt && (errorState || error)"
    class="idp-input__wrapper"
  >
    <div aria-hidden="true" aria-live="off">
      <idp-error-tooltip
        *ngIf="focused && submitAttempt && (errorState || error)"
        [arrowPosition]="arrowPosition"
        [errorMessage]="errorMessage"
        [icon]="true"
        data-test-error-tooltip="true"
      ></idp-error-tooltip>
    </div>

    <ng-container
      *ngIf="
        helpModal?.icon === true || labelIcon === true;
        then inputWithHelp;
        else inputWithoutHelp
      "
    ></ng-container>
    <ng-template #inputWithoutHelp>
      <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
    </ng-template>
    <ng-template #inputWithHelp>
      <div *ngIf="helpModal.icon || labelIcon" class="help-icon--wrapper">
        <idp-help-icon
          *ngIf="helpModal.icon && !labelIcon"
          [modalContent]="helpModal.content"
          [modalTitle]="helpModal.title"
          [modalType]="helpModal.type"
          [srText]="helpModal.title"
          [tooltipContent]="helpModal.content"
          [tooltip]="helpModal.tooltip || false"
          [modalStyle]="helpModal.modalStyle || 'slim'"
          [closeOnBackgroundClick]="helpModal.closeOnBackgroundClick || false"
          [hideCloseButton]="helpModal.hideCloseButton || false"
        ></idp-help-icon>
        <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
      </div>
    </ng-template>
    <ng-template #inputTemplate>
      <ng-container *ngIf="!floatingLabel">
        <ng-container *ngTemplateOutlet="inputLabel"></ng-container>
      </ng-container>
      <ng-container *ngIf="infoToolTip && infoToolTipContent">
        <idp-info-icon
          (iconClicked)="iconToolTipClick()"
          *ngIf="infoToolTip"
          [labelSrOnly]="labelSrOnly"
          [labelTitle]="labelHelpIcon"
          [ngClass]="{ 'idp-input--info-toolTip': infoToolTip }"
          [srText]="ariaLabel"
          class="infoIcon"
          [ariaRole]="toolTipAriaRole"
        ></idp-info-icon>
      </ng-container>
      <input
        data-lpignore="true"
        (blur)="setFocused(false, $event)"
        (focus)="setFocused(true, $event)"
        (focusout)="setFocusOut($event)"
        (keydown)="!shouldDisable($event)"
        (keyup)="!disabled && setValue($event)"
        (keyup.tab)="emitTabKeyHit($event)"
        (paste)="setValuePaste($event)"
        (change)="autoFillDetectChange($event)"
        [(ngModel)]="defaultValue"
        [attr.aria-disabled]="disabled ? true : null"
        [attr.aria-invalid]="
          invalidAriaRequired && submitAttempt && (errorState || error)
        "
        [attr.aria-label]="ariaLabel ? ariaLabel : labelTxt"
        [attr.aria-required]="required"
        [attr.disabled]="disableFocus ? true : null"
        [attr.maxlength]="maxLength"
        [attr.name]="name"
        [attr.placeholder]="placeholderText"
        [attr.readonly]="disabled || disableFocus ? true : null"
        [attr.required]="required && ariaRequired ? required : null"
        [attr.type]="strictNumbers ? 'text' : type"
        [attr.validElement]="validElement"
        [attr.value]="defaultValue"
        [attr.id]="id"
        [class.idp-input--disabled]="disabled || disableFocus"
        [class.idp-input--hide-bottom-border]="hideBottomBorder"
        [class.tlMaskInfo]="addtlMaskInfo"
        [ngClass]="
          submitAttempt && (errorState || error) ? 'idp-input--error' : ''
        "
        [style.width]="'100%'"
        autocomplete="off"
        class="idp-input"
        (input)="handleInput($event)"
      />
      <span class="idp-input--bar" hidden></span>
      <ng-container *ngIf="floatingLabel">
        <ng-container *ngTemplateOutlet="inputLabel"></ng-container>
      </ng-container>
      <ng-container *ngIf="eyeIcon">
        <span
          (click)="togglePassword($event)"
          (keydown)="togglePassword($event)"
        >
          <span
            [attr.aria-label]="showPassword ? 'hide password' : 'show password'"
            [ngClass]="{
              'idp-input__eyeicon-unmasked--toolTip':
                showPassword && infoToolTipContent,
              'idp-input__eyeicon-masked--toolTip':
                !showPassword && infoToolTipContent,
              'idp-input__eyeicon-unmasked':
                showPassword && !infoToolTipContent,
              'idp-input__eyeicon-masked': !showPassword && !infoToolTipContent
            }"
            role="button"
            tabindex="0"
          ></span>
        </span>
      </ng-container>
      <!-- Information tooltip help to be shown while clicking the toolTip Icon beside in input field -->
      <idp-error-tooltip
        (closePopUp)="closetoolTipClickContent('close')"
        (focusoutInfoToolTip)="closetoolTipClickContent('focus')"
        *ngIf="toolTipClickContent"
        [arrowPosition]="'right'"
        [closeEscInfoToolTip]="closeEscInfoToolTip"
        [closeIcon]="true"
        [hasLink]="hasLink"
        [errorMessage]="infoToolTipContent"
        [icon]="false"
        [infoToolTip]="infoToolTip"
        class="idp-input--info-toolTipContent"
        data-test-error-tooltip="false"
      ></idp-error-tooltip>
    </ng-template>
    <span
      *ngIf="focused && submitAttempt && (errorState || error)"
      aria-atomic="true"
      aria-live="polite"
      class="sr-only"
      role="alert"
    >
      {{ errorMessage }}
    </span>
    <span
      *ngIf="bottomLabelText"
      [attr.aria-hidden]="ariaLabel ? true : false"
      [id]="'btm_' + id"
      [innerHTML]="bottomLabelText"
      class="idp-input__label--bottom"
    ></span>
    <span
      *ngIf="description"
      aria-atomic="true"
      aria-live="polite"
      class="idp-input__description--message"
      [innerHTML]="descriptionMessage"
    ></span>
  </div>
</div>

<ng-template #inputLabel>
  <label
    *ngIf="!labelIcon"
    [attr.aria-hidden]="ariaLabel ? true : false"
    [ngClass]="{ 'idp-label--fixed': !floatingLabel }"
    class="idp-label"
  >
    {{ labelTxt }}
  </label>

  <label
    *ngIf="labelIcon"
    [ngClass]="{ 'idp-label--fixed': !floatingLabel }"
    class="idp-label"
  >
    {{ labelTxt }}
    <idp-help-icon
      [labelIcon]="true"
      [modalContent]="helpModal.content"
      [modalTitle]="helpModal.title"
      [modalType]="helpModal.type"
      [srText]="helpModal.title"
    ></idp-help-icon>
  </label>
</ng-template>
